<div class="event-container">
    <div class="event-wrapper" *ngIf="!mat_events_spinner">
        <div class="table-wrapper">
            <div class="bulk" *ngIf="bulkMode">
                <app-action-panel-bulk [data]="getMultiActionData()" (actionStatus)="updateAction($event)"></app-action-panel-bulk>
            </div>
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <input type="checkbox" class="shadow-none enable-action" [formControl]="selectAll">
                        </th>
                        <ng-container *ngFor="let head of tableHeaders">
                            <th class="with-sort enable-action" (click)="changeSort(head)">{{head.disp}}
                                <mat-icon class="content-xl">{{head.sort ? head.order == 'ASC' ? 'arrow_upward' : 'arrow_downward' : 'import_export'}}</mat-icon>
                            </th>
                        </ng-container>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let event of alertsList; index as i">
                        <tr>
                            <td>
                                <div class="add-btn border-light primary-text enable-action radius-m" (click)="openActionPanel(i)">
                                    <mat-icon>{{event.accordian ? 'remove' : 'add'}}</mat-icon>
                                </div>
                            </td>
                            <td [ngClass]="event.status == 2 ? '':''"><input type="checkbox" class="shadow-none enable-action" (change)="groupClick($event,event)" [checked]="event.selected"></td>
                            <td>{{event.alerttime | changetimezone : 'YYYY-MM-DD HH:mm:ss'}}</td>
                            <td>{{event.eventcount}}</td>
                            <td>
                                <div class="status content-m px-2 radius-m" [ngStyle]="alertvarservice.statusStyle[event.status]">{{getActionDisp(event.status)}}</div>
                            </td>
                            <td>{{event.assigned_user ? getUsername(event.assigned_user) : '' }}</td>
                            <td>
                                <!-- <div class="current_status px-2 content-m radius-m white-text enable-action" (click)="acknowledgeClick(event,index)" *ngIf="event.status == 0">Acknowledge</div> -->
                                <div class="actions-list" [ngClass]="event.selected ? 'permission-denied' : ''">
                                    <ng-container *ngFor="let action of getApplicableActions(event.status) |keyvalue:originalOrder">
                                        <div class="current_status px-2 radius-m content-m  enable-action" *ngIf="!action.value.isDefault" [ngStyle]="alertvarservice.statusStyle[action.value.value]" (click)=actionClick(i,event,action.value)>
                                            <mat-icon>{{action.value.icon}}</mat-icon>
                                            <p class="m-0">{{action.value.actionDisp}}</p>
                                        </div>
                                    </ng-container>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="event.accordian">
                            <td class="action-panel-td primary-bg" colspan="7">
                                <div class="alert-action-panel white-bg selected-list p-5">
                                    <!-- <div class="keyFields border-blue-bottom"> -->
                                    <div class="keyFields">
                                        <div class="keyFields-header">
                                            <div class="header-left">
                                                <div class="title primary-text">
                                                    <mat-icon class="content-xl">dns</mat-icon>
                                                    <p class="content-m">KEY FIELDS</p>
                                                </div>
                                            </div>
                                            <div class="header-right"></div>
                                        </div>
                                        <div class="keyFields-body p-3 border-light-top">
                                            <ng-container *ngFor="let val of event.eventdetails | keyvalue:originalOrder">
                                                <div class="pair">
                                                    <p class="content-m primary-text lightest-text">{{val.key}}</p>
                                                    <p class="content-m boldest-text primary-text">{{val.value}}</p>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <!-- <div class="action-panel">
                                        <app-action-panel [data]="getActionData(event)" (actionStatus)="updateAction($event,i)"></app-action-panel>
                                    </div> -->
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
    <div class="pagination p-3 border-light-top" *ngIf="!mat_events_spinner">
        <div class="pagination-left">
            <p class="primary-text lightest-text content-m">Showing</p>
            <p class="primary-text boldest-text content-m">{{alertsList.length}}</p>
            <p class="primary-text lightest-text content-m">of </p>
            <p class="primary-text boldest-text content-m">{{totalAlertCount}}</p>
            <p class="primary-text lightest-text content-m">alerts</p>
        </div>
        <div class="pagination-right border-light white-bg radius-m pr-3">
            <div class="pre-icon primary-text enable-action" [ngClass]="pageNumber == 1 ? 'permission-denied' : 'enable-action'" (click)="paginationClick(-1)">
                <mat-icon>chevron_left</mat-icon>
            </div>
            <div class="page-info">
                <p class="primary-text  content-m">Page</p>
                <p class="primary-text boldest-text content-m">{{pageNumber}}</p>
                <p class="primary-text  content-m">of</p>
                <p class="primary-text boldest-text content-m">{{pageLength ? pageLength : 1}}</p>
            </div>
            <div classs="next-icon primary-text enable-action" [ngClass]="pageNumber == pageLength ? 'permission-denied' : 'enable-action'" (click)="paginationClick(1)">
                <mat-icon>chevron_right</mat-icon>
            </div>
            <div class="itemsper-page-container">
                <p class="m-0 content-m  primary-text">Items per page:</p>
                <div class="items-per-page-list enable-action">
                    <app-overlay-select class="" overlaycontainer="border-none shadow-none" [data]="alertvarservice.itemsPerpageValueList" [formControl]="itemPerPage" sort="true"></app-overlay-select>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="mat_events_spinner">
        <div class="spinner-wrapper ">
            <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
        </div>
    </ng-container>

</div>

<ng-template #actionpanel let-dialogRef="dialogRef">
    <mat-dialog-content class="p-0 m-0">
        <div class="dialog-container">
            <app-set-action-panel [data]="setActionInput"></app-set-action-panel>
        </div>
    </mat-dialog-content>
</ng-template>